<template>
    <div v-show="visible">
        <el-dialog title="新增日期" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">          
                <el-form-item prop="date" label="日期">
                    <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                props: { checkStrictly: true},
                form:{
                    date:""
                },
                rules: {
                    date: [
                        { required: true, message: '请选择日期', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let data = {
                            date:this.form.date
                        };
                        // console.log(JSON.stringify(data));
                        this.$parent.addDate(data);
                        this.visible=false;
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/attendance/holidays/AddDate.vue